import React from 'react'

const InfoPayment = () => {
  return (
    <div className='content-text'>
        The Payment section displays manufacturer and dealer discounts, deposits, taxes, and surcharges, all of which are considered in the building cost. 
        <br /><br />
        <span>Surcharge - </span>To include a surcharge in the building cost, you can either add a new amount or update the existing value. 
        <br /><br />
        <span>Manufacturer Discount - </span> Applied to the building amount or base price. Any edited discount will be applied only to building amount. 
        <br /><br />
        <span>Tax - </span>To apply tax to the building cost, enter the zip code, and the system will automatically calculate the tax. You can also manually add tax by providing the zip code, type, and tax value in either $ or %. Multiple taxes can be added or removed using the +Add button or Remove button. 
        <br /><br />
        <span>Tax Exempt - </span>Click this button to mark the building as tax-exempt. Proof of exemption will be required upon order confirmation. 
        <br /><br />
        <span>Dealer Deposit - </span>To include or revise the dealer deposit in the building cost, enter the amount in dollars or percentage. Click the “%” icon and choose from the dropdown menu to select the deposit method (% or $). 
        <br /><br />
        <span>Dealer Discount - </span>To apply the dealer discount to the building cost, you can either add a new discount value or update the existing one. To choose the discount method (% or $), click on the “%” icon and select from the dropdown menu. 
        <br /><br />
        <span>Payment Mode - </span>Choose the payment mode for the building from the provided options.
    </div>
  )
}

export default InfoPayment